import { manageAPI } from "./index.js";

export const getPendingAnnouncements = async () => {
  return (await manageAPI.get("merchant/announcements/pending")).data;
};

export const dismissAnnouncement = async (id) => {
  return (await manageAPI.post(`merchant/announcements/${id}/dismiss`)).data;
};
